import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

import { Singleton } from '@denishussar/html5-game-engine';

export interface UserProps {
    name: string;
    score: number;
    achievements: string[];
}

@Singleton
export class FirebaseAPI {
    private _db: firebase.firestore.Firestore = null;

    public init(): void {
        firebase.initializeApp({
            apiKey: 'AIzaSyBSIjIYRyJVlbPM8d0EbxD3nA1pE9bMGsI',
            authDomain: 'vremyavozmozhnostey2021.firebaseapp.com',
            projectId: 'vremyavozmozhnostey2021',
            storageBucket: 'vremyavozmozhnostey2021.appspot.com',
            messagingSenderId: '544173565107',
            appId: '1:544173565107:web:7e488e22463ea9f5c07cc6',
            measurementId: 'G-B00M6NHT6J',
        });

        this._db = firebase.firestore();
    }

    public async load(id: string): Promise<UserProps> {
        if (id !== '') {
            const doc = await this._db.collection('users').doc(id);
            const snapshot = await doc.get();

            if (snapshot.exists) {
                const data = snapshot.data() as UserProps;

                console.log('load', id, data);

                return data;
            }
        }

        return null;
    }

    public async save(id: string, props: UserProps): Promise<string> {
        console.log('saveScore', id, props);

        if (id !== '') {
            const doc = await this._db.collection('users').doc(id);
            const snapshot = await doc.get();

            if (snapshot.exists) {
                doc.update(props);

                return id;
            }
        }

        const doc = await this._db.collection('users').add(props);

        return doc.id;
    }

    public async getUsers(): Promise<Map<string, UserProps>> {
        const map = new Map();
        const snapshot = await this._db.collection('users').get();

        for (let i = 0; i < snapshot.docs.length; i++) {
            const doc = snapshot.docs[i];

            map.set(doc.id, doc.data());
        }

        return map;
    }

    public async trackGameStart(gender: string): Promise<void> {
        firebase.analytics().setUserProperties({ gender: gender });
        firebase.analytics().logEvent('game_start', { gender: gender });
    }

    public async trackGameEnd(gender: string): Promise<void> {
        firebase.analytics().setUserProperties({ gender: gender });
        firebase.analytics().logEvent('game_end', { gender: gender });
    }
}
